import { z } from 'zod';

import { type QueriesType, QueriesTypeSchema } from '../telematics/types';
import { Api } from '@automapa/svelte-automapa-template';
import { NotificationSystemQueries } from './NotificationSystemQueries';
import {
    JobResponseSchema,
    JobWithRealisationAndRecentRejectionResponseSchema,
    type JobResponseType,
    type JobWithRealisationAndRecentRejectionResponseType,
} from '../Jobs/types';
import { ApiFilterBuilder } from '@automapa/svelte-automapa-template';

export class NotificationSystemApi {
    public static async getAdHocNotRejectedJobsCount(
        api: Api,
        ms: NotificationSystemQueries
    ): Promise<{ count: number }> {
        return api.getData<QueriesType, { count: number }>(
            'post',
            '/job/count/query',
            ms.getJobAdHocNotRejectedQuery(),
            QueriesTypeSchema,
            z.object({ count: z.number().catch(0) })
        );
    }

    public static async getAdhocRejectedJobsCount(
        api: Api,
        ms: NotificationSystemQueries
    ): Promise<{ count: number }> {
        return api.getData<QueriesType, { count: number }>(
            'post',
            '/job/count/query',
            ms.getJobAdHocRejectedQuery(),
            QueriesTypeSchema,
            z.object({ count: z.number().catch(0) })
        );
    }

    public static async getAdhocRejectedJobsData(api: Api, ms: NotificationSystemQueries) {
        return api.getData<QueriesType, JobResponseType[]>(
            'post',
            '/job/query',
            ms.getJobAdHocRejectedQuery(),
            QueriesTypeSchema,
            z.array(JobResponseSchema)
        );
    }

    public static async getAdhocNotRejectedJobsData(api: Api, ms: NotificationSystemQueries) {
        return api.getData<QueriesType, JobResponseType[]>(
            'post',
            '/job/query',
            ms.getJobAdHocNotRejectedQuery(),
            QueriesTypeSchema,
            z.array(JobResponseSchema)
        );
    }

    public static async getRejectedJobsCount(api: Api, day: string): Promise<{ count: number }> {
        return api.getData<QueriesType, { count: number }>(
            'post',
            '/assignment_job_rejections/count/query' +
                new ApiFilterBuilder(null).addRelation('job*').sortBy(null, null).getUri(),
            {
                day: day,
                'job.rejected': true,
                assignment_id: { $column: 'job.rejected_assignments.-1::int' },
                'job.completed_as_planned': null,
            },
            QueriesTypeSchema,
            z.object({ count: z.number().catch(0) })
        );
    }

    public static async getRejectedJobsData(
        api: Api,
        day: string
    ): Promise<JobWithRealisationAndRecentRejectionResponseType[]> {
        return api.getData<any, JobWithRealisationAndRecentRejectionResponseType[]>(
            'post',
            '/jobs/query' +
                new ApiFilterBuilder(null)
                    .addRelation('assignment_job_rejection*')
                    .setProjectionFields([
                        'job.*',
                        'assignment_job_rejection>driver_info@rejection',
                    ])
                    .sortBy(null, null)
                    .getUri(),
            {
                day: day,
                'job.rejected': true,
                'job.completed_as_planned': null,
                'rejected_assignments.-1::int': {
                    $column: 'assignment_job_rejection.assignment_id',
                },
            },
            z.any(),
            z.array(JobWithRealisationAndRecentRejectionResponseSchema)
        );
    }
}
